'use client';

import { useZmyleCookie } from 'hooks/useZmyleCookie';
import { ClientConfig } from 'services/clientConfig';

import { FacebookPixel } from './FacebookPixel';
import { LinkedInInsight } from './LinkedInInsight';
import { GoogleTagManager } from './GoogleTagManager';
import { isGoogleAdsEnabled } from './lib';

export const MarketingScripts = () => {
  const zmyleCookie = useZmyleCookie(state => state.zmyleCookie);

  const { marketing } = zmyleCookie.consents;

  const clientConfig = ClientConfig.getInstance().getConfig();

  const isFacebookPixelEnabled =
    Boolean(clientConfig.facebookPixelId) &&
    marketing.includes('facebook-pixel');

  const isLinkedinInsightEnabled =
    Boolean(clientConfig.linkedinPartnerId) &&
    marketing.includes('linkedin-insight-tag');

  return (
    <>
      {isGoogleAdsEnabled(zmyleCookie) && <GoogleTagManager />}

      <FacebookPixel isEnabled={isFacebookPixelEnabled} />

      <LinkedInInsight isEnabled={isLinkedinInsightEnabled} />
    </>
  );
};
